/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import VPagination from "@hennge/vue3-pagination";


export default {
  name: "ICFVideos",
     components: {
      VPagination,customModal
    },
  props: {
    icfId: {
      type: [String, Number],
      required: true,
    },
    icfName: {
      type: String,
      required: true,
    },
    icfVersion: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showLoading: false,
      videoList: [],
      token: "",
      studyId: "",
      baseurl: process.env.VUE_APP_Service_URL,
      
      // Upload popup properties
      showUploadPopup: false,
      loadingUpload: false,
      videoTitle: "",
      videoDescription: "",
      selectedFile: null,
      
      // Validation errors
      errors: {
        title: false,
        file: false,
        fileType: false,
      },
    };
  },
  computed: {
      rollsprivilages() {
        return store.getters.getRolesprivilegeData || [];
      }
      
    // modalTitle() {
    //   const versionSuffix = this.icfVersion ? `_v${this.icfVersion}` : "";
    //   return `Manage ICF Videos – ${this.icfName}${versionSuffix}`;
    // },
  },
  async mounted() {
    this.token = store.getters.getIdToken;
    this.studyId = store.getters.getStudyIs;
    await this.fetchVideos();
  },
  methods: {
async fetchVideos() {
  this.showLoading = true;
  try {
    const response = await axios.get(
      `${this.baseurl}/management/video/videolist?studyId=${this.studyId}&icfFormId=${this.icfId}`,
      {
        headers: {
          Authorization: "Bearer " + this.token,
          "Content-Type": "application/json",
        },
      }
    );
    
    console.log("Video list response:", response.data);
    if (response.data && response.data.data) {
      this.videoList = response.data.data.map(video => ({
        id: video.id,
        videoTitle: video.videoTitle || video.videoName || '-', 
        title: video.videoTitle || video.videoName || '-',     
        fileName: video.videoName,
        videoName: video.videoName,
        description: video.videoDescription,
        extension: video.extention,
        reference: video.referance,
        icfFormId: video.icfFormId,
        studyId: video.studyId,
        createdAt: video.CreatedAt,
        createdBy: video.CreatedUserEmail,
        rawData: video
      }));
    } else {
      this.videoList = [];
    }
    
    this.totalCount = response.data.totalCount || 0;
    
  } catch (err) {
    console.error("Error fetching videos:", err);
    this.videoList = [];
    this.totalCount = 0;
  } finally {
    this.showLoading = false;
  }
},

    openUploadModal() {
      this.showUploadPopup = true;
      this.resetUploadForm();
    },

    closeUploadModal() {
      this.showUploadPopup = false;
      this.resetUploadForm();
    },

    resetUploadForm() {
      this.videoTitle = "";
      this.videoDescription = "";
      this.selectedFile = null;
      this.errors = {
        title: false,
        file: false,
        fileType: false,
      };
      if (this.$refs.videoFileInput) {
        this.$refs.videoFileInput.value = "";
      }
    },

    browseVideo() {
      this.$refs.videoFileInput.click();
    },

    previewVideo(event) {
      const file = event.target.files[0];
      if (file) {
        const validTypes = ["video/mp4", "video/webm", "video/ogg"];
        if (!validTypes.includes(file.type)) {
          this.errors.fileType = true;
          this.selectedFile = null;
          this.$refs.videoFileInput.value = "";
          return;
        }
        
        this.errors.fileType = false;
        this.selectedFile = file;
      }
    },

    removeFile() {
      this.selectedFile = null;
      this.$refs.videoFileInput.value = "";
      this.errors.file = false;
    },

    validateUploadForm() {
      let isValid = true;
      
      if (!this.videoTitle.trim()) {
        this.errors.title = true;
        isValid = false;
      } else {
        this.errors.title = false;
      }
      
      if (!this.selectedFile) {
        this.errors.file = true;
        isValid = false;
      } else {
        this.errors.file = false;
      }
      
      return isValid;
    },

    async submitVideoUpload() {
  if (!this.validateUploadForm()) {
    return;
  }

  this.loadingUpload = true;

  const formData = new FormData();
  formData.append("Data", this.selectedFile);
  formData.append("icfFormId", this.icfId);
  formData.append("studyId", this.studyId);
  formData.append("Title", this.videoTitle);
  formData.append("videoDescription", this.videoDescription);
  formData.append("videoName", this.selectedFile.name);

  try {
    const uploadResponse = await axios.post(
      `${this.baseurl}/management/video/uploadvideo`,
      formData,
      {
        headers: {
          Authorization: "Bearer " + this.token,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    
    console.log("Upload response:", uploadResponse.data);
    alert("Video uploaded successfully!");
    this.closeUploadModal();
    await this.fetchVideos(); // Refresh the list
  } catch (err) {
    console.error("Upload error:", err);
    
    // More detailed error handling
    if (err.response?.data?.errors) {
      const errorMessages = Object.values(err.response.data.errors).flat();
      alert(errorMessages.join("\n"));
    } else if (err.response?.data?.detail) {
      alert(err.response.data.detail);
    } else if (err.response?.data?.message) {
      alert(err.response.data.message);
    } else {
      alert("Video upload failed. Please try again.");
    }
  } finally {
    this.loadingUpload = false;
  }
},

    async deleteVideo(videoId) {
      if (!confirm("Are you sure you want to delete this video?")) return;
      
      try {
        // Replace with your actual delete API endpoint
        await axios.delete(
          `${this.baseurl}/management/video/deletevideo?Id=${videoId}`,
          {
            headers: {
              Authorization: "Bearer " + this.token,
              "Content-Type": "application/json",
            },
          }
        );
        
        alert("Video deleted successfully.");
        await this.fetchVideos();
      } catch (err) {
        console.error("Delete error:", err);
        alert(err.response?.data?.detail || "Delete failed.");
      }
    },

    closeModal() {
      this.$emit("close");
    },
  },
};